<script setup>
    import { ref } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { storeToRefs } from 'pinia'
    import { useStageStore } from '@/stores/stage';
    import { useForm } from 'vee-validate';
    import router from '@/router';

    const formStorage = useStageStore();
    const { t } = useI18n()
    const nameSpace = formStorage.getNameSpace;
    const { showDraftMessage, showDraftForm, previewMode } = storeToRefs(formStorage)

    // Create the form
    const { defineInputBinds, handleSubmit, errors } = useForm({
        validationSchema: {
            formPassword: 'passwordRule',
            formEmail: 'emailRule'
        },
    });

    // Submit handler
    const onSubmit = handleSubmit(async (values) => {
        const password = values.formPassword ?? '';
        const email = values.formEmail ?? '';
        
        const surveySent = await formStorage.sendSurveyFormData({
            [ `${nameSpace}cmd` ]: 'update',
            [ `${nameSpace}workflowAction` ]: '2',
            [ `${nameSpace}password` ]: password,
            [ `${nameSpace}email` ]: email
        });
                
        if (!surveySent) {
            console.error("Survey saveAsDraft failed")
            return;
        }
        
        showDraftMessage.value = true;
        showDraftForm.value = false;
    });

    // Define fields
    const formPassword = defineInputBinds('formPassword');
    const formEmail = defineInputBinds('formEmail');

</script>

<template>
    <form
        id="save-as-draft-form"
        @submit="onSubmit"
        class="column"
    >
        <div class="column mb-4 draft-password">
            <label for="formPassword" class="primary-label">{{ t('draft-form.input.draft-password') }}</label>
            <input 
                id="formPassword" 
                :class="errors.formPassword ? 'has-error': ''" 
                type="password" 
                v-bind="formPassword" 
                :placeholder="t('draft-form.info.draft-password')"
            >
            <span v-if="errors.formPassword">{{ t(`draft-form.validation.${errors.formPassword}`) }}</span>
        </div>

        <div class="column mb-4 draft-email">
            <label for="formEmail" class="primary-label">{{ t('draft-form.input.draft-email') }}</label>
            <label for="formEmail" class="secondary-label">{{ t('draft-form.info.draft-email-extra') }}</label>
            <input 
                id="formEmail" 
                type="email" 
                :class="errors.formEmail ? 'has-error': ''" 
                v-bind="formEmail" 
                :placeholder="t('draft-form.info.draft-email')"
            >
            <span v-if="errors.formEmail">{{ t(`draft-form.validation.${errors.formEmail}`) }}</span>
        </div>

        <div class="row">
            <button @click="showDraftForm = false" class="btn btn-secondary" type="button">{{ t('button.cancel') }}</button>
            <button :disabled="previewMode" class="btn btn-primary" type="submit">{{ t('button.save-draft') }}</button>
        </div>
    </form>
</template>